import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";
import { showToast } from "./ToastSlice";

export const sendEmail = createAsyncThunk(
  "email/sendEmail",
  async (emailData, { rejectWithValue, dispatch }) => {
    try {

      const response = await api.post("/sendEmail", emailData);

      dispatch(
        showToast({
          message: response.data.message || "Email sent successfully",
          variant: "success",
        })
      );
      return response.data;
    } catch (error) {
      console.log("error from sendMail thunk", error);

      // Extract error message with proper fallbacks
      let errorMessage = "Failed to send email";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.data?.error) {
        errorMessage =
          typeof error.response.data.error === "string"
            ? error.response.data.error
            : JSON.stringify(error.response.data.error);
      } else if (error.message) {
        errorMessage = error.message;
      }

      dispatch(showToast({ message: errorMessage, variant: "danger" }));
      return rejectWithValue(error.response?.data || { message: errorMessage });
    }
  }
);

const emailSlice = createSlice({
  name: "email",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {
    resetEmailState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendEmail.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendEmail.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to send email";
      });
  },
});

export const { resetEmailState } = emailSlice.actions;
export default emailSlice.reducer;
